import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, WineIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productEdition, productImage, productImageAlt, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} volumi completi`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} bonus esclusivi`
}];
export function Hero() {
  const scrollToOffer = () => document.getElementById('offerta')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden" data-id="element-82" data-mp="sb1chsl5257m">
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-83" data-mp="s9ghy2ytqm9r">
        <span className="flex-1 bg-surface" data-id="element-84" data-mp="nczrv382dxu1" />
        <span className="w-24 bg-accent" data-id="element-85" data-mp="neax77h5rdn9" />
        <span className="flex-1 bg-surface" data-id="element-86" data-mp="3d21ty23jwspu" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-87" data-mp="3czfm01cr0b73">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-accent/40 bg-background/55 px-4 py-2 text-[11px] font-bold uppercase tracking-[.14em] text-foreground sm:text-xs" data-id="element-88" data-mp="3814brpijjyoc">
          <WineIcon className="h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-89" data-mp="3e7ux7oa2kpoc" /> {productBrand} · {productEdition}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto mt-8 max-w-3xl" data-id="element-90" data-mp="358rbsdnfjy6o">
          <div className="pointer-events-none absolute inset-0 -z-10 flex items-center justify-center" aria-hidden="true" data-id="element-91" data-mp="2vgu25bc2lea2">
            <span className="absolute h-[70%] w-[70%] rounded-full bg-primary/25 blur-[90px]" data-id="element-92" data-mp="2lkimqch6o8be" />
            <span className="absolute h-[55%] w-[85%] translate-y-[10%] rounded-full bg-[#7a1f33]/50 blur-[80px]" data-id="element-93" data-mp="s21k8hdb6o2m" />
          </div>
          <img src={productImage} alt={productImageAlt} className="relative mx-auto w-full" data-id="element-94" data-mp="naa1gt0e9mn1" />
        </motion.div>

        <div className="mt-8" data-id="element-95" data-mp="id048r6rk6on">
          <Button onClick={scrollToOffer} arrow className="w-full sm:w-auto" data-id="element-96" data-mp="i9vr34bbm0lu">
            Voglio l&apos;Edizione Professionale
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-foreground" data-id="element-97" data-mp="1azku1n7lcaq3">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-accent/25 bg-background/55 px-3 py-2" data-id="element-98" data-mp="1126o4hjan4c1">
              <Icon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-99" data-mp="x0l48c8cdpsc" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}